<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>



            <div class="scrolling-content-products bg-color">
                <v-layout row wrap class="page-content">
                    <v-flex md10 xs12 align-start class="no-padding-bottom" v-if="sponsors">
                        <h2 class="page-title">{{text('db.global.TYPE_GTS_WELCOME_TITLE_D')}}</h2>
                        <div>
                            <span class="margin-right-xxs" v-html="text('db.global.TYPE_GTR_PAGE_WELCOME_TEXTFIELD_1')"></span>
                        </div>
                    </v-flex>

                    <v-flex lg12 md12 align-start class="no-padding-bottom" v-else>
                        <div class="page-title">{{text('db.global.TYPE_GTS_WELCOME_TITLE_D')}}</div>
                        <div>
                            <span class="margin-right-xxs" v-html="text('db.global.TYPE_GTR_PAGE_WELCOME_TEXTFIELD_1')"></span>
                        </div>
                    </v-flex>

                    <v-flex lg12 md12 align-end class="activate-product" v-if="getUserData.role === 'USER'">
                        <v-btn color="primary" @click="showActivationCodePopup()" class="float-right no-margin-right text-uppercase font-weight-light" v-if="getUserData.role === 'USER'">{{text('api.button.activationcode')}}</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row wrap class="body-home">
                    <v-flex v-if="sponsors" lg9 md8 sm12 xs12>
                        <product-list @onClickProduct="handleClickProduct"></product-list>
                    </v-flex>

                    <v-flex v-else lg12 sm12 xs12>
                        <product-list @onClickProduct="handleClickProduct"></product-list>
                    </v-flex>

                    <v-flex lg3 md4 sm12 class="sponsors" v-if="sponsors">
                       <sponsors-list></sponsors-list>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>

        <code-popup></code-popup>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import HeaderBar from '../shared/HeaderBar';
    import chooseProductSvg from "../../../common/components/svg/productList/chooseProduct";
    import CodePopup from '../../../common/components/shared/ActivationCodePopup';
    import ProductList from '../../../common/components/shared/ProductList';
    import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
    import SponsorsList from '../../../common/components/shared/SponsorsList';
    import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';

    export default {
        name: 'HomePage',
        components: {
            HeaderBar,
            chooseProductSvg,
            CodePopup,
            ProductList,
            AcceptCookie,
            SponsorsList,
            DetectBrowserCookie
        },

        beforeCreate() {
            // Reset stores.
            this.$store.commit('ProductListStore/resetStore');
            this.$store.commit('AssessmentStartStore/resetStore');
            this.$store.commit('ChooseMainSymptomStore/resetStore');
            this.$store.commit('SymptomsQuestionsStore/resetStore');
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('ScoringStore/resetStore');
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');

            // Clear chatbot related session storage data.
            sessionStorage.removeItem("smass-home-route");
            sessionStorage.removeItem("pfiAssessmentToken");
            sessionStorage.removeItem("crtChatbotSection");
        },

        created () {
            // Load product list data from server.
            this.$store.dispatch('ProductListStore/loadProductListPageData');
        },


        computed: mapGetters({
            products: 'ProductListStore/getProductList',
            getUserData: 'UserStore/getUserData',
            sponsors: 'ProductListStore/getSponsorList',
            getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList'
        }),

        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup'
            }),
            // Component methods.
            handleClickProduct (productCode) {
                this.$store.dispatch('ProductListStore/selectProduct', productCode).then(() => {
                    if(!this.getMustShowAssessmentList) {
                        this.$router.push('/assessment-start');
                    } else {
                        this.$router.push('/assessment-start-list');
                    }
                });
            },
            hideTestPopup() {
                this.$store.commit('ProductListStore/setMustShowActivationCodePopup', false);
            }
        },

        data () {
            return {
                // @TODO Do we need this?
                items: [
                    {
                        src: 'static/img/in4medicine_logo.svg',
                        title: 'in4medicine',
                        description: 'Medizin und Informatik - ein starkes Team.'
                    }
                ]
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            margin-bottom: -60px;
            padding-top: 2px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-block-border;
    }

    .icon-start-assessment {
        font-size: 36px;
    }

    .sponsors {
        border-radius: 5px;
    }



</style>



// WEBPACK FOOTER //
// src/professional/components/home/HomePage.vue